/**
 * Format start/end date strings into a compact year range.
 * Examples: "2020–2023", "2020–Present", "Present"
 */
export const formatDateRange = (start: string, end: string): string => {
  const startYear = start ? start.slice(0, 4) : '';
  const endYear = end ? end.slice(0, 4) : 'Present';
  if (!startYear) return endYear;
  if (startYear === endYear) return startYear;
  return `${startYear}\u2013${endYear}`;
};
